import { render, staticRenderFns } from "./ResetHomeworkMarkDialog.vue?vue&type=template&id=24d4ef52"
import script from "./ResetHomeworkMarkDialog.vue?vue&type=script&lang=js"
export * from "./ResetHomeworkMarkDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports